export enum FetchMandatesTypes {
  GET_REQUEST = 'Mandates/List/GET_REQUEST',
  GET_SUCCESS = 'Mandates/List/GET_SUCCESS',
  GET_FAILURE = 'Mandates/List/GET_FAILURE',
  OPEN = 'Mandates/List/OPEN',
}
